import { buildFilterProductsQuery } from '@vue-storefront/core/helpers'
import { mapGetters } from 'vuex'
import pickBy from 'lodash-es/pickBy'
import store from '@vue-storefront/core/store'

export default {
  name: 'CategorySidebar',
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('category', ['getCurrentCategory', 'getActiveCategoryFilters', 'getCurrentCategoryProductQuery']),
    category () {
      return this.getCurrentCategory
    },
    activeFilters () {
      return this.getActiveCategoryFilters
    },
    availableFilters () {
      return pickBy(this.filters, (filter) => { return (filter.length) })
    },
    hasActiveFilters () {
      return Object.keys(this.activeFilters).length !== 0
    }
  },
  mounted () {
    this.resetAllFilters()
  },
  methods: {
    sortById (filters) {
      return [...filters].sort((a, b) => { return a.id - b.id })
    },
    resetAllFilters () {
      if (this.hasActiveFilters) {
        this.$bus.$emit('filter-reset')
        this.$store.dispatch('category/resetFilters')
        this.$store.dispatch('category/searchProductQuery', {})
        this.$store.dispatch('category/mergeSearchOptions', {
          searchProductQuery: buildFilterProductsQuery(this.category, this.activeFilters),
          // CORE OVERRIDE
          filters: this.filters,
          sort: store.state.config.products.defaultSortBy.attribute + (store.state.config.products.defaultSortBy.order ? ':' + store.state.config.products.defaultSortBy.order : ''),
          current: 0,
          perPage: 16
        })
        this.$store.dispatch('category/products', this.getCurrentCategoryProductQuery)
      }
    }
  }
}
